import { render } from "./FormSelect.vue?vue&type=template&id=d87f3fa4&bindings={\"modelValue\":\"props\",\"required\":\"props\",\"config\":\"props\",\"uuid\":\"props\",\"label\":\"props\",\"options\":\"props\",\"disableNoSelection\":\"props\",\"validations\":\"props\",\"labelHtml\":\"options\",\"update\":\"options\"}"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"
script.render = render

export default script